import { RegistrationScreen } from '@/components/utils/RegistrationScreen';
import * as P from '@/constants/paths';
import useRegistrationKitId from '@/hooks/registration/useRegistrationKitId';
import { useUserStore } from '@/hooks/useUserStore';
import { TextField } from '@design-system/DataForm/TextField';
import { RegistrationCancerDetectAndTrialBundle } from './RegistrationCancerDetect';

export const RegistrationKitId = () => {
  const {
    form,
    formOnValid,
    errorMessageStr,
    isKitQueryLoading,
    configureOnChange,
    showRegisterInterrupt,
    disableNext,
  } = useRegistrationKitId();
  const { user: userData } = useUserStore();
  const previousPathFromKitidPage = userData
    ? P.ACCOUNT_MANAGEMENT_PATH
    : P.REGISTRATION_LANDING;

  const ERROR_MESSAGES = {
    KIT_ALREADY_ASSIGNED: 'This kit has already been assigned to a Viome user. Try a different kit.',
    WRONG_BARCODE_FORMAT: 'Kit ID does not exist. Please try again.',
    BARCODE_NOT_FOUND: 'Kit ID does not exist. Please try again.',
    KIT_MUST_BE_REGISTERED_BY_SUBSCRIBER: 'Please log in with the email you provided during your purchase.',
    KIT_EXPIRED: 'Unfortunately, this kit is now expired and cannot be registered. A Viome kit must be registered within 6 months of purchase.',
    BARCODE_NOT_MATCH_WITH_USER: 'The kit id does not exists or is not purchased under this user',
    KIT_MUST_BE_PAID: 'Please check your email for the link to complete the order by paying the balance for your Viome Oral Health Pro with CancerDetect test.'
  } as const;

  const generatingErrorMessage = (errorMessageArg: string) => {
    return ERROR_MESSAGES[errorMessageArg as keyof typeof ERROR_MESSAGES] || 'Kit ID does not exist. Please try again.';
  };

  return showRegisterInterrupt ? (
    <RegistrationCancerDetectAndTrialBundle interrupt={showRegisterInterrupt} />
  ) : (
    <RegistrationScreen
      form={form}
      formOnValid={formOnValid}
      title="Enter kit ID"
      description="The ID is located within the instruction booklet with the kit."
      content={
        <div className="mt-8" data-testid="registrationKitId-content">
          <TextField
            name="kitId"
            placeholder="####-####-####"
            onChange={configureOnChange}
            minLength={14}
            data-testid="registrationKitId-input"
          />
        </div>
      }
      previousPath={previousPathFromKitidPage}
      primaryActionLabel={'Next'}
      primaryActionIsSubmit
      primartActionDisabled={disableNext}
      isLoading={isKitQueryLoading}
      errorMessage={errorMessageStr && generatingErrorMessage(errorMessageStr)}
      data-testid="registrationKitId-screen"
    />
  );
};
